/**
 * @returns {string} the path outside the base URL
 */
export const getSessionPath = () => {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};
